<script setup lang="ts">
import {
    NotificationTemplate as INotificationTemplate,
    NotificationTemplateTag
} from "@/notification-template/interfaces";
import NotificationTemplate from "@/notification-template/components/NotificationTemplate.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {useRoute, useRouter} from "vue-router";
import {useExtensionStore} from "@/stores/extension.store";
import {storeToRefs} from "pinia";
import Extension from "@/core/interfaces/extension/Extension";
import ExtensionNavigationService from "@/extension/services/ExtensionNavigationService";
import {computed} from "vue";

const props = defineProps<{
    tag: NotificationTemplateTag | null;
    templates: INotificationTemplate[];
}>();

defineEmits<{
    (e: 'templateSelected', template: INotificationTemplate);
}>();

const route = useRoute();
const router = useRouter();

const extensionStore = useExtensionStore();
const {programExtensions} = storeToRefs(extensionStore);

const extension = computed(() => {
    if(props.tag?.type !== 'program') {
        return null;
    }

    return programExtensions.value.find(_extension => {
        return _extension.program_bundle.programs.some(program => program.id === props.tag!.id);
    });
});

const redirect = (_extension: Extension) => {
    ExtensionNavigationService.navigate(_extension, router, route, {consumerTab: true});
};
</script>

<template>
  <div
    class="flex flex-col gap-4"
  >
    <div v-if="tag" class="flex flex-wrap items-center gap-2">
      <div class="shadow-md rounded-md shadow-muted-foreground overflow-hidden">
        <img v-if="tag.logo" :src="tag.logo" class="w-12 object-contain">
      </div>
      <h2 class="text-lg font-semibold">
        {{ tag.name }} ({{ templates.length }} modèle{{ templates.length > 1 ? 's' : '' }})
      </h2>
    </div>

    <hr v-else class="mb-12">

    <div class="flex flex-wrap gap-8">
      <div
        v-for="template in templates"
        :key="template.id"
        class="flex flex-col gap-2 items-center"
      >
        <NotificationTemplate
          class="min-w-xl max-w-2xl"
          :template="template"
          selectable
          select-label="Recevoir ce SMS"
          @selected="_template => $emit('templateSelected', _template)"
        >
          <template #before-select-button>
            <div v-if="extension" class="mb-2">
              <BaseButton density="comfortable" @click="redirect(extension)">
                Envoyer aux patients ciblés
              </BaseButton>
            </div>
          </template>
        </NotificationTemplate>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
